'use client'
import { motion } from 'motion/react'
import { useSlate } from 'slate-react'
import React from 'react'
import { isBlockActive } from '../funcitons'
import { addNode, removeElement } from '../services/node'

export const BlockButton = ({
  format,
  className,
  children,
}: {
  format: string
  children: React.ReactNode
  className?: string
}) => {
  const editor = useSlate()
  const [isActive, node] = isBlockActive(editor, format)

  return (
    <motion.div whileTap={{ scale: 0.95 }}>
      <button
        type={'button'}
        className={`toolbar-button ${isActive ? 'active' : ''} ${className ? ` ${className}` : ''}`}
        onMouseDown={(event) => {
          event.preventDefault()
          if (!isActive) {
            addNode(editor, {
              type: format,
              text: '',
            })
          } else {
            removeElement(editor, format)
          }
        }}>
        {children}
      </button>
    </motion.div>
  )
}
